import s from './style/home.module.scss';
import { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import { Tooltip } from 'antd';
import GrtImage from '@/components/GrtImage';

import aiImg from '@/assets/images/web/ai.png';
import homeImg from '@/assets/images/web/home_bg.jpg';
// import homeImg from '@/assets/images/web/222.jpg';
const WebOutsideHome = (props) => {
    const { getAgentList, state } = props.store.grtAi;
    const { agentList = [] } = state;
    const onClick = (item) => {
        localStorage.setItem('agent6Id ', item.id);
        window.open(`${window.location.origin}/agent/web/o/${item.id}/chat`);
    };
    useEffect(() => {
        getAgentList();
    }, []);

    return (
        <div className={s['home-wrap']}>
            <img className={s['img']} src={homeImg} alt="" />
            <div className={s['box-wrap']}>
                <div className={s['agent-recommend']}>
                    <img src={aiImg} alt="" />
                    智能体推荐
                </div>
                <div className={s['list-wrap']}>
                    {agentList.map((ele, index) => {
                        return (
                            <div
                                className={s['list-item']}
                                key={index}
                                onClick={() => {
                                    onClick(ele);
                                }}
                            >
                                <div className={s['item-top']}>
                                    <div className={s['img-box']}>
                                        <GrtImage src={ele.agent_icon}></GrtImage>
                                    </div>
                                    <div className={s['text-name']}> {ele.name}</div>
                                </div>
                                <Tooltip title={ele.description}>
                                    <div className={s['item-bottom']}>{ele.description}</div>
                                </Tooltip>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
export default withRouter(inject('store')(observer(WebOutsideHome)));
